import { ActionTree, GetterTree, MutationTree } from "vuex";
import { State } from "@/typings/store";
import { StateDrawer } from "@/typings/store/modules/drawer";

const state: StateDrawer = {
  drawer: true,
};

const getters: GetterTree<StateDrawer, State> = {
  get(state) {
    return state.drawer;
  },
};

const mutations: MutationTree<StateDrawer> = {
  set(state, data: boolean) {
    state.drawer = data;
  },
};

const actions: ActionTree<StateDrawer, State> = {
  set(ctx, data: boolean) {
    ctx.commit("set", data);
  },
};

const drawer = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default drawer;
